import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page not found";
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 py-12"
      style={{
        fontFamily: "var(--font-primary)",
        background: "#f1f6ff",
      }}
    >
      <div className="text-center max-w-md">
        {/* 404 number - theme accent */}
        <p
          className="text-[clamp(4rem,15vw,8rem)] font-extrabold leading-none tracking-tighter opacity-15 select-none"
          style={{ color: "var(--dark-blue)" }}
        >
          404
        </p>

        <h1
          className="text-[clamp(1.5rem,4vw,2rem)] font-bold mt-2 mb-3"
          style={{ color: "var(--dark-blue)" }}
        >
          Page not found
        </h1>

        <p
          className="text-base leading-relaxed mb-8"
          style={{ color: "var(--meta)" }}
        >
          The page you’re looking for doesn’t exist or may have been moved. No
          worries—you can head back and continue from there.
        </p>

        <Link
          to="/"
          className="btn btn-primary btn-md"
          style={{ textDecoration: "none" }}
        >
          Return to dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
